import { atom } from 'jotai'

import { OrderFormSummaryTab } from '@/state/order'

// Order types that have a first-use guide in the order form. To add one: map its tab
// below, add `orderTypeGuide.<key>` copy to every messages/*.json, and drop
// `<key>-buy.json` / `<key>-sell.json` into public/lottie/order-form/{dark,light}.
export const ORDER_TYPE_GUIDE_BY_TAB = {
  [OrderFormSummaryTab.Limit]: 'limit',
  [OrderFormSummaryTab.Market]: 'market',
  [OrderFormSummaryTab.TWAP]: 'twap',
} as const satisfies Partial<Record<OrderFormSummaryTab, string>>

export type OrderTypeGuideKey =
  (typeof ORDER_TYPE_GUIDE_BY_TAB)[keyof typeof ORDER_TYPE_GUIDE_BY_TAB]

export function orderTypeGuideKeyForTab(tab: OrderFormSummaryTab): OrderTypeGuideKey | undefined {
  return (ORDER_TYPE_GUIDE_BY_TAB as Partial<Record<OrderFormSummaryTab, OrderTypeGuideKey>>)[tab]
}

export type OrderTypeGuideSeen = Partial<Record<OrderTypeGuideKey, boolean>>

/** Stored in the data-manager widget config under this key: `{ [userId]: OrderTypeGuideSeen }`. */
export const ORDER_TYPE_GUIDE_CONFIG_KEY = 'orderTypeGuide'

/** userId -> guides that user has dismissed. Seeded by DataManagerSync from the server. */
export const orderTypeGuideSeenAtom = atom<Record<string, OrderTypeGuideSeen>>({})
